// cleanup_console_errors_eslint_GENERICS
// cleanup_convert_to_typescript_file_GENERICS

/* eslint-disable global-require */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import CheckUser from 'components/auth/CheckUser';
import Bootstrap from 'components/bootstrap/Bootstrap';
import LeadBankCode from 'components/leadBankCode/LeadBankCode';
import ThemeProvider from 'components/theme/ThemeProvider';
import { AppConfigProvider } from 'components/appConfig/AppConfig';
import { BankConfigProvider } from 'components/bankConfig/BankConfig.tsx';
import AppInfo from 'components/appInfo/AppInfo';
import CommonErrorSnackbar from 'components/userEmulation/CommonErrorSnackbar';
import AxiosContext from 'components/axios/AxiosContext';
import AxiosFactory from 'components/axios/AxiosFactory';
import GluOverride from 'components/gluOverride/GluOverride';
import { ROUTER_BASENAME } from 'constants.js';

import './glu.css';
import './index.css';
import store from './logic';

const Index = ({ component: Component }) => {
  const Axios = useMemo(() => new AxiosFactory(), []);

  return (
    <Provider store={store}>
      <Router basename={ROUTER_BASENAME}>
        <LeadBankCode>
          <AppConfigProvider>
            {({ appConfig }) => {
              Axios.setAppConfig(appConfig);
              return (
                <CheckUser>
                  <BankConfigProvider>
                    <ThemeProvider>
                      {({ ready, theme }) => (
                        <GluOverride theme={theme}>
                          <AppInfo>
                            <CommonErrorSnackbar />
                            <AxiosContext.Provider value={Axios}>
                              <Component theme={theme} themeReady={ready} />
                            </AxiosContext.Provider>
                          </AppInfo>
                        </GluOverride>
                      )}
                    </ThemeProvider>
                  </BankConfigProvider>
                </CheckUser>
              );
            }}
          </AppConfigProvider>
        </LeadBankCode>
      </Router>
    </Provider>
  );
};
Index.propTypes = {
  component: PropTypes.func.isRequired
};

const render = (Component) => {
  ReactDOM.render(<Index component={Component} />, document.getElementById('root'));
};

render(Bootstrap);

if (module.hot) {
  module.hot.accept('components/bootstrap/Bootstrap', () => {
    const NextBootstrap = require('components/bootstrap/Bootstrap').default;
    render(NextBootstrap);
  });
}
